var sen_in = false;

$(window).scroll(function () {
  let scrollTop = $(window).scrollTop(); // スクロール上部の位置
  let pc_bnr02_areaTop = $("#pc_bnr02").offset().top - 200; // 対象エリアの上部の位置
  let pc_bnr03_areaTop = $("#pc_bnr03").offset().top - 200; // 対象エリアの上部の位置
  let text_sen_wrapper_areaTop_pc = $("#text_sen_wrapper").offset().top - 100; // 対象エリアの上部の位置
  let text_sen_wrapper_areaTop_sp = $("#text_sen_sp").offset().top; // 対象エリアの上部の位置
  let text_sen_wrapper_areaTop_sp_height = text_sen_wrapper_areaTop_sp + 1000; // 対象エリアの上部の位置
  console.log('scroll');

  if (scrollTop >= pc_bnr02_areaTop) {
    //console.log('pc_bnr02-in')
    //$("#pc_bnr02").addClass("isShow"); // スクロールが対象エリアに入った場合
    $('#pc_bnr02 .eachTextAnime').each(function () {
      $(this).addClass("appeartext");
    });
  }

  if (scrollTop >= pc_bnr03_areaTop) {
    //console.log('pc_bnr03-in')
    //$("#pc_bnr02").addClass("isShow"); // スクロールが対象エリアに入った場合
    $('#pc_bnr03 .eachTextAnime').each(function () {
      $(this).addClass("appeartext");
    });
  }

  if (scrollTop >= text_sen_wrapper_areaTop_pc) {
    console.log('pc_sen_in');
    sen_in = true;
    console.log('sen_in : ' + sen_in);
  } else {
    console.log('pc_sen_out');
    sen_in = false;
    console.log('sen_in : ' + sen_in);
  }

  if (scrollTop >= text_sen_wrapper_areaTop_sp && scrollTop <= text_sen_wrapper_areaTop_sp_height) {
    console.log('sp_sen_in');
    $("#text_sen_mask_wrapper").css("display", "flex"); // スクロールが対象エリアに入った場合
  } else if (scrollTop > text_sen_wrapper_areaTop_sp_height) {
    console.log('sp_sen_out');
    $("#text_sen_mask_wrapper").css("display", "none"); // スクロールが対象エリア外の場合
  } else {
    console.log('sp_sen_out');
    $("#text_sen_mask_wrapper").css("display", "none"); // スクロールが対象エリア外の場合
  }

});

window.addEventListener('scroll', function () {
  if (scrollTop > pc_bnr02_areaTop) {
    //console.log(pc_bnr02_areaTop);
    let scroll_stop_and_fade02 = (scrollTop / pc_bnr02_areaTop) - 1;
    // console.log(scroll_stop_and_fade02);
    $('#vertical_textbox_bnr02').css('opacity', scroll_stop_and_fade02);
  }
  if (scrollTop > pc_bnr03_areaTop) {
    //console.log(pc_bnr03_areaTop);
    let scroll_stop_and_fade03 = (scrollTop / pc_bnr03_areaTop) - 0.75;
    //console.log(scroll_stop_and_fade03);
    $('#vertical_textbox_bnr03').css('opacity', scroll_stop_and_fade03);
  }
})

//PCの場合はマウスオーバーで開閉
$('.logo_side_dog').hover(
  function () {//マウスカーソルが重なった時の処理
    if (!$(this).hasClass('active')) {//'.active'クラスがないときのみ実行
      $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0666/6928/1515/files/ds_logo_side_dog_apng.png?v=1676627356');
      $(this).addClass('active');
      $(this).delay(3500).queue(function () {
        $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0666/6928/1515/files/ds_logo_side_dog.png?v=1676627354');
        $(this).removeClass('active');
        $(this).dequeue();
      });
    }
  },
  function () {//マウスカーソルが離れた時の処理
    $(this).delay(3500).queue(function () {
      $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0666/6928/1515/files/ds_logo_side_dog.png?v=1676627354');
      $(this).removeClass('active');
      $(this).dequeue();
    });
  }
);

//スマホやタブレットはタッチで開閉
var clickEventType = ((window.ontouchstart !== null) ? 'click' : 'touchend');
$('.logo_side_dog').on(clickEventType, function () {
  if (!$(this).hasClass('active')) {//'.active'クラスがないときのみ実行
    $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0666/6928/1515/files/ds_logo_side_dog_apng.png?v=1676627356');
    $(this).addClass('active');
    $(this).delay(3500).queue(function () {
      $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0666/6928/1515/files/ds_logo_side_dog.png?v=1676627354');
      $(this).removeClass('active');
      $(this).dequeue();
    });
  } else {
    $(this).delay(3500).queue(function () {
      $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0666/6928/1515/files/ds_logo_side_dog.png?v=1676627354');
      $(this).removeClass('active');
      $(this).dequeue();
    });
  }
});



//動画の遅延読み込み
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') === -1) || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0) {
  console.log('iOS');
}else{
  console.log('PC,Mac');
  //全画面移動 (PC)
  (function () {
    'use strict';
    // 変数
    var wrap = document.getElementById('wrap'),
      elements = document.querySelectorAll('#wrap .scroll_container_child'), // 1画面分スクロールさせる要素
      elRect = [], // 要素の位置情報を取得するための配列
      elTop = [], // 要素の位置を入れるための配列
      count = 0, //
      wheelFlag = false;
    // 各要素の位置を取得
    function getElTop() {
      for (var i = 0; i < elements.length; i++) { // 要素の数ループ
        elRect.push(elements[i].getBoundingClientRect()); // 要素の位置情報を配列へ
      }
      for (var i = 0; i < elRect.length; i++) { // 要素の数ループ
        elTop.push(elRect[i].top + window.scrollY); // 要素の位置を配列へ
      }
    }
    getElTop();
    // 画面リサイズのときの処理
    window.addEventListener('resize', function () {
      console.log('resize');
      elRect = []; // 位置情報の配列を一旦空に
      elTop = []; // 位置の配列を一旦空に
      getElTop(); // 位置を取得
      window.scrollTo(0, elTop[count]); // 現在表示中の画面位置へ
    });
    // マウスホイールのときの処理
    wrap.addEventListener('wheel', function (e) {
      if (sen_in == false) {
        e.preventDefault(); // デフォルトのスクロール動作を削除
        if (!wheelFlag) { // wheelFlagがfalseのときに発動
          wheelFlag = true; // wheelFlagをtrueにして無駄に発動しないように
          if (e.deltaY > 0) { // ホイールが下方向だったら
            if (count >= elements.length - 1) { // 要素の数以上に増えないようにcountが要素の数を超えたら
              count = elements.length - 1; // countを要素の数とする
            } else {
              count++; // それまではcountをプラス
            }
          } else if (e.deltaY < 0) { // ホイールが上方向だったら
            if (count <= 0) { // 0より小さくならないようにcountが0以下なら
              count = 0; // countを0とする
            } else {
              count--; // それまではcountをマイナスしていく
            }
          }
          setTimeout(function () { //0.8秒後にwheelFlagをfalseにして次のページめくれるように
            wheelFlag = false;
          }, 1500);
          setTimeout(function () {
            window.scrollTo({ // count番目の要素へスクロール
              top: elTop[count],
              behavior: 'smooth',
            });
          }, 20); // スクロールまで時間差をつけて慣性スクロール対策
        }
      }
    });
  }());

}

//スムーススクロール
// (function () {
//   const offset = 0; // ヘッダーの高さ
//   const links = document.querySelectorAll('a[href^="#"]');
//   links.forEach((link) => {
//     link.addEventListener('click', (event) => {
//       event.preventDefault();
//       let href = link.getAttribute('href').substr(1);
//       href = href == '#' ? 'html' : `[id="${href}"]`;
//       const target = document.querySelector(href);
//       const rect = target.getBoundingClientRect();
//       const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//       const position = rect.top + scrollTop - offset;
//       window.scrollTo({
//         top: position,
//         behavior: 'smooth'
//       });
//     });
//   });
// }());
